import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { UsersThree } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";

export default function JoinClassCard() {
  const { lang } = useTranslation();
  const es = lang === "es";
  const { user } = useAuth();
  const [cls, setCls] = useState(undefined);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get("/api/me/class", { withCredentials: true }).then((r) => setCls(r.data.class)).catch(() => setCls(null));
  }, []);

  if (cls === undefined || user?.role === "admin") return null;

  const join = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post("/api/me/class", { code }, { withCredentials: true });
      setCls(data.class);
      setCode("");
      toast.success(es ? `Te uniste a ${data.class.name}` : `You joined ${data.class.name}`);
    } catch {
      toast.error(es ? "Código de clase no encontrado" : "Class code not found");
    }
    setBusy(false);
  };

  const leave = async () => {
    await axios.delete("/api/me/class", { withCredentials: true });
    setCls(null);
  };

  return (
    <div className="flex items-center gap-3 flex-wrap bg-[#121214]/80 border border-white/10 rounded-xl px-4 py-3" data-testid="join-class-card">
      <UsersThree weight="fill" className="w-5 h-5 text-[#F5A524] shrink-0" />
      {cls ? (
        <>
          <p className="text-sm text-[#D4D4D8] flex-1" data-testid="join-class-current">
            {es ? "Tu clase: " : "Your class: "}
            <span className="text-white font-medium">{cls.name}</span>
          </p>
          <Button variant="ghost" size="sm" onClick={leave} className="text-[#71717A] hover:text-white" data-testid="join-class-leave">
            {es ? "Salir de la clase" : "Leave class"}
          </Button>
        </>
      ) : (
        <>
          <p className="text-sm text-[#A1A1AA] flex-1 min-w-[180px]">{es ? "¿Tu profesor te dio un código de clase?" : "Did your teacher give you a class code?"}</p>
          <div className="flex gap-2">
            <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && code && join()} maxLength={6} placeholder="ABC123" className="w-28 bg-[#0A0A0A] border-white/10 text-white font-['JetBrains_Mono'] uppercase" data-testid="join-class-input" />
            <Button onClick={join} disabled={busy || code.length < 6} className="bg-[#F5A524] text-[#0A0A0A] hover:bg-[#F5B041]" data-testid="join-class-btn">
              {es ? "Unirme" : "Join"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
